/**
 * @module geo/actions/creators
 *
 */
import {promiseActionCreator} from '../../helpers/observable.to.promise';
import {SERVICE_CALL_METHOD} from '../../payload/facade/services/SERVICE_CALL_METHOD';
import {SERVICE_CALL_REST} from '../../payload/facade/services/SERVICE_CALL_REST';
import {SERVICE_EXECUTE_SEARCH} from '../../payload/facade/services/SERVICE_EXECUTE_SEARCH';
import {SERVICE_FEATURE_TRANSACTION} from '../../payload/facade/services/SERVICE_FEATURE_TRANSACTION';
import {SERVICE_EXCEPTION} from '../../payload/proxy/SERVICE_EXCEPTION';
import {ExecuteSearch} from '../../types/services/execute.search';
import {FeaturesTransaction} from '../../types/services/features.transaction';
import {Acknowledged} from '../../payload/response/acknowledged';
import {actionCreator} from '../helpers/actions.creator.builder';
import {ActionCreator} from '../helpers/fsa';
import {TypeKeyActions} from '../types.key.action';

/**
 * return an action builder to call service method
 * @type {ActionCreator<SERVICE_CALL_METHOD>}
 * @since v 2.1.0
 */
export const callServiceMethodCreator =
    actionCreator<SERVICE_CALL_METHOD>(TypeKeyActions.SERVICE_CALL_METHOD) as
    ActionCreator<SERVICE_CALL_METHOD>;
/**
 * action type of getServiceCreatorAsyncCreator
 * @type {AsyncActionCreators<SERVICE_CALL_METHOD, Acknowledged, any>}
 * @since v 2.1.0
 */
export const callServiceMethodAsyncCreator =
    actionCreator.async<SERVICE_CALL_METHOD, Acknowledged, SERVICE_EXCEPTION>(
        TypeKeyActions.SERVICE_CALL_METHOD);
/**
 * return an action builder to call service method
 * @type {ActionCreator<SERVICE_CALL_METHOD>}
 * @since v 2.1.0
 * @private
 * @hidden
 */
export const callServiceMethodCreatorP =
    promiseActionCreator(callServiceMethodCreator, [
      callServiceMethodAsyncCreator.done.type,
      callServiceMethodAsyncCreator.failed.type
    ]);

/**
 * return an action builder to call service method
 * @type {ActionCreator<SERVICE_CALL_REST>}
 * @since v 2.1.0
 */
export const callServiceRESTCreator =
    actionCreator<SERVICE_CALL_REST>(TypeKeyActions.SERVICE_CALL_REST) as
    ActionCreator<SERVICE_CALL_REST>;
/**
 * action type of getServiceCreatorAsyncCreator
 * @type {AsyncActionCreators<SERVICE_CALL_REST, Acknowledged, SERVICE_EXCEPTION>}
 * @since v 2.1.0
 */
export const callServiceRESTAsyncCreator =
    actionCreator.async<SERVICE_CALL_REST, Acknowledged, SERVICE_EXCEPTION>(
        TypeKeyActions.SERVICE_CALL_REST);
/**
 * return an action builder to call service method
 * @type {ActionCreator<SERVICE_CALL_REST>}
 * @since v 2.1.0
 * @private
 * @hidden
 */
export const callServiceRESTCreatorP =
    promiseActionCreator(callServiceRESTCreator, [
      callServiceRESTAsyncCreator.done.type,
      callServiceRESTAsyncCreator.failed.type
    ]);
/**
 * return an action builder to call service method
 * @type {ActionCreator<SERVICE_FEATURE_TRANSACTION>}
 * @since v 2.1.0
 */
export const serviceFeatureTransactionCreator =
    actionCreator<SERVICE_FEATURE_TRANSACTION>(
        TypeKeyActions.SERVICE_FEATURE_TRANSACTION) as
    ActionCreator<SERVICE_FEATURE_TRANSACTION>;
/**
 * action type of getServiceCreatorAsyncCreator
 * @type {AsyncActionCreators<SERVICE_FEATURE_TRANSACTION, FeaturesTransaction, SERVICE_EXCEPTION>}
 * @since v 2.1.0
 */
export const serviceFeatureTransactionAsyncCreator = actionCreator.async<
    SERVICE_FEATURE_TRANSACTION, FeaturesTransaction, SERVICE_EXCEPTION>(
    TypeKeyActions.SERVICE_FEATURE_TRANSACTION);



/**
 * return an action builder to call service method
 * @type {ActionCreator<SERVICE_FEATURE_TRANSACTION>}
 * @since v 2.1.0
 * @private
 * @hidden
 */
export const serviceFeatureTransactionCreatorP =
    promiseActionCreator(serviceFeatureTransactionCreator, [
      serviceFeatureTransactionAsyncCreator.done.type,
      serviceFeatureTransactionAsyncCreator.failed.type,
      serviceFeatureTransactionAsyncCreator.started.type
    ]);
/**
 * return an action builder to call service method
 * @type {ActionCreator<SERVICE_EXECUTE_SEARCH>}
 * @since v 2.1.0
 */
export const serviceExecuteSearchCreator =
    actionCreator<SERVICE_EXECUTE_SEARCH>(TypeKeyActions.SERVICE_EXECUTE_SEARCH) as
    ActionCreator<SERVICE_EXECUTE_SEARCH>;
/**
 * action type of getServiceCreatorAsyncCreator
 * @type {AsyncActionCreators<SERVICE_EXECUTE_SEARCH, ExecuteSearch, SERVICE_EXCEPTION>}
 * @since v 2.1.0
 */
export const serviceExecuteSearchAsyncCreator =
    actionCreator
        .async<SERVICE_EXECUTE_SEARCH, ExecuteSearch, SERVICE_EXCEPTION>(
            TypeKeyActions.SERVICE_EXECUTE_SEARCH);
/**
 * return an action builder to call service method
 * @type {ActionCreator<SERVICE_EXECUTE_SEARCH>}
 * @since v 2.1.0
 * @private
 * @hidden
 */
export const serviceExecuteSearchCreatorP =
    promiseActionCreator(serviceExecuteSearchCreator, [
      serviceExecuteSearchAsyncCreator.done.type,
      serviceExecuteSearchAsyncCreator.failed.type,
      serviceExecuteSearchAsyncCreator.started.type
    ]);
